import React from "react";
import { Button, Label, Modal, ModalBody, ModalHeader } from "reactstrap";

function ModalEdit({
  args,
  isOpen,
  toggle,
  close,
  dataEdit,
  onChange,
  onKeyUp,
  onClick,
  error,
}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} {...args}>
      <ModalHeader toggle={toggle} close={close}>
        <span className="t-primary fs-4 fw-bold">Edit</span>
      </ModalHeader>
      <ModalBody className="px-4">
        <div className="w-100">
          <div>
            <Label className="mb-2">Last Name</Label>
            <input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="lastname"
              onChange={onChange}
              onKeyUp={onKeyUp}
              defaultValue={dataEdit.lastname}
            />
          </div>

          {error.lastname && <p className="error">{error.lastname}</p>}

          <div className="mt-2">
            <div>
              <Label className="mb-2">First Name</Label>
              <input
                className="fs-6 border_input rounded w-100"
                type="text"
                name="firstname"
                onChange={onChange}
                onKeyUp={onKeyUp}
                defaultValue={dataEdit.firstname}
              />
            </div>

            {error.firstname && <p className="error">{error.firstname}</p>}
          </div>

          <div className="mt-2">
            <Label className="mb-2">Phone</Label>
            <input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="phone"
              onChange={onChange}
              onKeyUp={onKeyUp}
              defaultValue={dataEdit.phone}
            />
          </div>

          {error.phone && <p className="error">{error.phone}</p>}

          <div className="mt-2">
            <Label className="mb-2">Email</Label>
            <input
              className="fs-6 border_input rounded w-100"
              type="text"
              name="email"
              onChange={onChange}
              onKeyUp={onKeyUp}
              defaultValue={dataEdit.email}
            />
          </div>

          {error.email && <p className="error">{error.email}</p>}
        </div>

        <div className="d-flex justify-content-center mt-4">
          <Button
            className="btn_add w-50"
            onClick={onClick}
            data-id={dataEdit.id}
          >
            Save
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default ModalEdit;
